const initialState = [];
//
export default function ch0301(state = initialState, action) {
  switch (action.type) {
    case 'SET_CH0301':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CH0301_ERROR':
      return state;
    default:
      return state;
  }
}
